/* ============================================================
   SKINDAE — consolidated theme JS (deferred, event-delegated)
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_URL = root + 'cart/add.js';
  var CART_URL = root + 'cart.js';

  function announce(msg) {
    var el = document.getElementById('status-announcement');
    if (el) el.textContent = msg;
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    fetch(CART_URL).then(function (r) { return r.json(); }).then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
    }).catch(function () {});
  }

  function addItems(items, button, successLabel) {
    var original = button.textContent;
    button.textContent = 'Adding\u2026';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        button.textContent = successLabel || 'Added \u2713';
        announce('Item added to your cart');
        refreshCart();
        setTimeout(function () {
          button.textContent = original; button.disabled = false; button.removeAttribute('aria-busy');
        }, 1800);
      })
      .catch(function () {
        button.textContent = 'Try again'; button.disabled = false; button.removeAttribute('aria-busy');
        announce('Sorry, that could not be added to your cart');
        setTimeout(function () { button.textContent = original; }, 2200);
      });
  }

  document.addEventListener('click', function (e) {
    /* ---- Ingredient tabs ---- */
    var itab = e.target.closest('[data-sk-ingtab]');
    if (itab) {
      var idx = itab.getAttribute('data-sk-ingtab');
      var wrap = itab.closest('.sk-ingtabs');
      if (wrap) {
        wrap.querySelectorAll('[data-sk-ingtab]').forEach(function (t) {
          t.classList.remove('on'); t.setAttribute('aria-selected', 'false');
        });
        itab.classList.add('on'); itab.setAttribute('aria-selected', 'true');
        wrap.querySelectorAll('[data-sk-ingpanel]').forEach(function (p) {
          var match = p.getAttribute('data-sk-ingpanel') === idx;
          p.hidden = !match;
          p.classList.toggle('on', match);
        });
      }
      return;
    }

    /* ---- Pack selector (1 / 2 / 3 units) ---- */
    var pack = e.target.closest('[data-sk-pack]');
    if (pack) {
      var qty = parseInt(pack.getAttribute('data-sk-pack'), 10) || 1;
      var group = pack.closest('.sk-packs');
      if (group) {
        group.querySelectorAll('[data-sk-pack]').forEach(function (p) {
          p.classList.remove('on'); p.setAttribute('aria-checked', 'false');
        });
      }
      pack.classList.add('on');
      pack.setAttribute('aria-checked', 'true');
      var qtyInput = document.getElementById('sk-qty-input');
      if (qtyInput) qtyInput.value = qty;
      var stickyBtn = document.querySelector('.sk-sticky-btn[data-sk-quick-add]');
      if (stickyBtn) stickyBtn.setAttribute('data-sk-qty-multiplier', qty);
      announce(qty + (qty === 1 ? ' unit selected' : ' units selected'));
      return;
    }

    /* ---- Quick add ---- */
    var qa = e.target.closest('[data-sk-quick-add]');
    if (qa) {
      e.preventDefault();
      var id = parseInt(qa.getAttribute('data-sk-quick-add'), 10);
      var mult = parseInt(qa.getAttribute('data-sk-qty-multiplier'), 10) || 1;
      if (id) addItems([{ id: id, quantity: mult }], qa);
      return;
    }

    /* ---- Add pair ---- */
    var pair = e.target.closest('[data-sk-add-pair]');
    if (pair) {
      e.preventDefault();
      var items = pair.getAttribute('data-sk-add-pair').split(',').map(function (v) {
        return { id: parseInt(v, 10), quantity: 1 };
      }).filter(function (i) { return i.id; });
      if (items.length) addItems(items, pair);
      return;
    }

    /* ---- UCIN ---- */
    var ucin = e.target.closest('[data-skindae-ucin]');
    if (ucin) {
      e.preventDefault();
      var url = ucin.getAttribute('data-ucin-url');
      var vid = ucin.getAttribute('data-variant-id');
      var qEl = document.getElementById('sk-qty-input');
      var q = qEl ? parseInt(qEl.value || '1', 10) : 1;
      var go = function () { window.location.href = url && url.length ? url : '/checkout'; };
      ucin.disabled = true;
      ucin.setAttribute('aria-busy', 'true');
      if (vid) {
        fetch(ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: q }] })
        }).then(go).catch(go);
      } else { go(); }
      return;
    }

    /* ---- Gallery thumbnails ---- */
    var thumb = e.target.closest('[data-sk-thumb]');
    if (thumb) {
      var main = document.getElementById('sk-gal-img');
      if (main) main.src = thumb.getAttribute('data-sk-thumb');
      document.querySelectorAll('.sk-gal-thumb').forEach(function (t) {
        t.classList.remove('on'); t.setAttribute('aria-current', 'false');
      });
      thumb.classList.add('on');
      thumb.setAttribute('aria-current', 'true');
      return;
    }

    /* ---- YouTube facade ---- */
    var yt = e.target.closest('[data-sk-yt]');
    if (yt) {
      var vwrap = yt.closest('.sk-vid');
      var ytId = yt.getAttribute('data-sk-yt');
      if (vwrap && ytId) {
        var frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + ytId + '?autoplay=1&rel=0';
        frame.title = 'Product video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        vwrap.innerHTML = '';
        vwrap.appendChild(frame);
      }
      return;
    }
  });

  /* ---- Variant picker sync ---- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('#sk-variant');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var money = opt.getAttribute('data-price');
    var now = document.getElementById('sk-price-now');
    if (now && money) now.textContent = money;
    var sp = document.getElementById('sk-sticky-price');
    if (sp && money) sp.textContent = money;
    document.querySelectorAll('[data-variant-id]').forEach(function (b) { b.setAttribute('data-variant-id', sel.value); });
    document.querySelectorAll('[data-sk-quick-add]').forEach(function (b) { b.setAttribute('data-sk-quick-add', sel.value); });
  });
})();
